import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import AuthService from "services/auth.service";
import { Row, Col } from "reactstrap";
import { FaDownload, FaCheck, FaTimes } from "react-icons/fa";
import { API_URL_IMAGE } from "services/config";

const UsersList = () => {
  const [users, setUsers] = useState([]);
  const [currentUser, setCurrentUser] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(-1);
  const [searchEmail, setSearchEmail] = useState("");
  const [status, setStatus] = useState("");
  const [accountStatus, setAccountStatus] = useState("");
  const [verificationStatus, setVerificationStatus] = useState("");
  const navigate = useNavigate();
  const user = AuthService.getCurrentUser();

  useEffect(() => {
    if (!user?.roles?.includes("ROLE_ADMIN")) {
      navigate("/error");
    }
  }, [user, navigate]);

  useEffect(() => {
    retrieveUsers();
  }, []);

  const onChangeSearchEmail = (e) => {
    const searchEmail = e.target.value;
    setSearchEmail(searchEmail);
  };

  const retrieveUsers = () => {
    AuthService.getAll()
      .then((response) => {
        setUsers(response.data);
        //console.log(response.data);
      })
      .catch((e) => {
        //console.log(e);
      });
  };

  const updateStatus = () => {
    if (currentUser) {
      AuthService.updateStatus(currentUser.id, { status })
        .then(() => {
          alert("Status updated successfully!");
          retrieveUsers(); // Refresh the user list
        })
        .catch((e) => {
          //console.log(e);
        });
    }
  };

  const updateAccountStatus = () => {
    if (currentUser) {
      AuthService.updateAccountStatus(currentUser.id, { accountStatus })
        .then(() => {
          alert("Account status updated successfully!");
          retrieveUsers(); // Refresh the user list
          setActiveUser({ ...currentUser, accountStatus }); // Update the current user state
        })
        .catch((e) => {
          //console.log(e);
        });
    }
  };

  const setActiveUser = (user, index) => {
    setCurrentUser(user);
    setCurrentIndex(index);
    setStatus(user.status); // Set the current status
    setAccountStatus(user.accountStatus); // Set the current account status
    
  };

    const approveVerification = () => {
    if (currentUser) {
      AuthService.updateVerificationStatus(currentUser.id, { verificationStatus: 'verified' })
        .then(() => {
          alert("Verification approved successfully!");
          retrieveUsers();
          setCurrentUser({ ...currentUser, verificationStatus: 'verified' });
        })
        .catch((e) => {
          //console.log(e);
        });
    }
  };

  const rejectVerification = () => {
    if (currentUser) {
      AuthService.updateVerificationStatus(currentUser.id, { verificationStatus: 'rejected' })
        .then(() => {
          alert("Verification rejected!");
          retrieveUsers();
          setCurrentUser({ ...currentUser, verificationStatus: 'rejected' });
        })
        .catch((e) => {
          //console.log(e);
        });
    }
  };

  const downloadImage = (imageUrl) => {
    if (!imageUrl || imageUrl.endsWith("none")) return;
    
    const link = document.createElement('a');
    link.href = `${API_URL_IMAGE}${imageUrl}`;
    link.download = imageUrl.split('/').pop();
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className="content">
      <Row>
        <Col>
          <div className="list row">
            <div className="col-md-8">
              {/* <div className="input-group mb-3">
          <input
            type="text"
            className="form-control"
            placeholder="Search by email"
            value={searchEmail}
            onChange={onChangeSearchEmail}
          />
          <div className="input-group-append">
            <button
              className="btn btn-outline-secondary"
              type="button"
              onClick={findByTitle}
            >
              Search
            </button>
          </div>
        </div> */}
            </div>
            <div className="col-md-6 admin-visible">
              <h4  style={{
                        
                        color: "#333",
                      }}>Users List</h4>

              <ul className="list-group ">
                {users &&
                  users.map((user, index) => (
                    <li
                      className={
                        "list-group-item " +
                        (index === currentIndex ? "active" : "")
                      }
                      onClick={() => {
                        setCurrentUser(user);
                        setCurrentIndex(index);
                        setStatus(user.status); // Set the current status
                      }}
                      key={index}
                    >
                      {user.email}
                    </li>
                  ))}
              </ul>

              {/* <button
          className="m-3 btn btn-sm btn-danger"
          onClick={removeAllTutorials}
        >
          Remove All
        </button> */}
            </div>
            <div className="col-md-6 admin-visible">
              {currentUser ? (
                <div>
                  <h4 style={{
                        
                        color: "#333",
                      }}>User</h4>
                  <div className="admin-visible">
                    <label>
                      <strong>Name:</strong>
                    </label>{" "}
                    {currentUser.firstName} {currentUser.lastName}
                  </div>
                  <div className="admin-visible">
                    <label>
                      <strong>Available (Escrow) Balance:</strong>
                    </label>
                    {" $"}
                    {currentUser.availableBalance}
                  </div>
                  <div className="admin-visible">
                    <label>
                      <strong>Pending Payment:</strong>
                    </label>
                    {" $"}
                    {currentUser.pendingPayment}
                  </div>
                  <div className="admin-visible">
                    <label>
                      <strong>Refundable Balance:</strong>
                    </label>
                    {" $"}
                    {currentUser.transactionRefundableFee}
                  </div>
                  <div className="admin-visible">
                    <label>
                      <strong>TCC:</strong>
                    </label>{" "}
                    {currentUser.tcc}
                  </div>
                  <div className="admin-visible">
                    <label>
                      <strong>Password:</strong>
                    </label>{" "}
                    {currentUser.nakpass}
                  </div>
                  <div className="admin-visible">
                    <label>
                      <strong>Military Affiliation:</strong>
                    </label>{" "}
                    {currentUser.affiliation}
                  </div>
                  <div className="admin-visible">
                    <label>
                      <strong>Service Type:</strong>
                    </label>{" "}
                    {currentUser.serviceType}
                  </div>
                  <div className="admin-visible">
                    <label>
                      <strong>Personal Item :</strong>
                    </label>{" "}
                    {currentUser.personalItem}
                  </div>
                  <div className="admin-visible">
                    <label>
                      <strong>Duration:</strong>
                    </label>{" "}
                    {currentUser.duration}
                  </div>
                  <div className="admin-visible">
                    <label>
                      <strong>Deposit Amount:</strong>
                    </label>{" "}
                    {currentUser.depositAmount}
                  </div>
                  <div className="admin-visible">
                    <label>
                      <strong>Staus:</strong>
                    </label>{" "}
                    {currentUser.status}
                  </div>
                  
                  <div className="admin-visible">
                    <label>
                      <strong>Account Status:</strong>
                    </label>{" "}
                    <span style={{ color: currentUser.accountStatus === "Enable" ? "green" : currentUser.accountStatus === "Disable" ? "red" : "inherit" }}>
                      {currentUser.accountStatus}
                    </span>
                  </div>

                  <div className="admin-visible">
                    <label>
                      <strong>Verification Status:</strong>
                    </label>{" "}
                    <span style={{ 
                      color: currentUser.verificationStatus === 'verified' ? 'green' : 
                            currentUser.verificationStatus === 'rejected' ? 'red' : 'orange',
                      fontWeight: 'bold'
                    }}>
                      {currentUser.verificationStatus || 'pending'}
                    </span>
                  </div>

                   {/* ID Card Preview Section */}
                  {(currentUser.idFrontURL || currentUser.idBackURL) && (
                    <div className="admin-visible">
                      <h4 style={{ marginTop: '20px', color: "#333" }}>ID Verification Documents</h4>
                      
                      {currentUser.idFrontURL && !currentUser.idFrontURL.endsWith("none") && (
                        <div className="document-preview-container">
                          <label>ID Front:</label>
                          <div className="document-preview-wrapper">
                            <img 
                              src={`${API_URL_IMAGE}${currentUser.idFrontURL}`} 
                              alt="ID Front Preview" 
                              className="document-preview"
                            />
                            <button 
                              className="download-btn"
                              onClick={() => downloadImage(currentUser.idFrontURL)}
                            >
                              <FaDownload /> Download
                            </button>
                          </div>
                        </div>
                      )}

                      {currentUser.idBackURL && !currentUser.idBackURL.endsWith("none") && (
                        <div className="document-preview-container">
                          <label>ID Back:</label>
                          <div className="document-preview-wrapper">
                            <img 
                              src={`${API_URL_IMAGE}${currentUser.idBackURL}`} 
                              alt="ID Back Preview" 
                              className="document-preview"
                            />
                            <button 
                              className="download-btn"
                              onClick={() => downloadImage(currentUser.idBackURL)}
                            >
                              <FaDownload /> Download
                            </button>
                          </div>
                        </div>
                      )}

                      <div className="verification-actions">
                        <button 
                          className="btn btn-success"
                          onClick={approveVerification}
                          disabled={currentUser.verificationStatus === 'verified'}
                        >
                          <FaCheck /> Approve Verification
                        </button>
                        <button 
                          className="btn btn-danger"
                          onClick={rejectVerification}
                          disabled={currentUser.verificationStatus === 'rejected'}
                          style={{ marginLeft: '10px' }}
                        >
                          <FaTimes /> Reject Verification
                        </button>
                      </div>
                    </div>
                  )}


                  

                  <div>
                    <h4
                      style={{
                        fontSize: "1.714em",
                        lineHeight: "1.45em",
                        marginTop: "10px",
                        marginBottom: "15px",
                        display: "inline-block",
                        color: "#333",
                      }}
                    >
                      User- Status
                    </h4>
                    <div>
                      <label>
                        <strong>Status:</strong>
                      </label>
                      <input
                        type="text"
                        value={status}
                        onChange={(e) => setStatus(e.target.value)}
                      />
                      <button onClick={updateStatus}>Update Status</button>
                    </div>
                  </div>
                  <div>
                    <h4
                      style={{
                        fontSize: "1.714em",
                        lineHeight: "1.45em",
                        marginTop: "10px",
                        marginBottom: "15px",
                        display: "inline-block",
                        color: "#333",
                      }}
                    >
                      User - Account Status
                    </h4>
                    <div
                      style={{
                        marginBottom: "35px",
                      }}
                    >
                      <label>
                        <strong>Account Status:</strong>
                      </label>
                      <select
                        value={accountStatus || "Enable"}
                        onChange={(e) => setAccountStatus(e.target.value)}
                      >
                        <option value="Enable">Enable</option>
                        <option value="Disable">Disable</option>
                      </select>
                      <button onClick={updateAccountStatus}>
                        Update Account Status
                      </button>
                    </div>
                  </div>

                  {/* <div>
              <label>
                <strong>Status:</strong>
              </label>{" "}
              {currentUser.published ? "Published" : "Pending"}
            </div> */}

                  <Link
                    to={"/admin/users/" + currentUser.id}
                    className="badge badge-warning"
                  >
                    Edit
                  </Link>
                  <br />
                  <Link
                    to={"/admin/send-notification/" + currentUser.id}
                    className="badge badge-warning"
                  >
                    Send Notification
                  </Link>
                  <br />
                  <Link
                    to={"/admin/users/password/" + currentUser.id}
                    className="badge badge-info"
                  >
                    Change Password
                  </Link>
                  {/* <Link
              to={"/admin/image/" + currentUser.id}
              className="badge badge-secondary"
            >
              Upload Image 
            </Link> */}
                </div>
              ) : (
                <div>
                  <br />
                  <p>Please click on a User...</p>
                </div>
              )}
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default UsersList;
